<template>
  <div>
    <sui-jqx-grid :dataSource="defaultGridData.dataSource" :columns="defaultGridData.columns" :columnsautoresize="true" :autoheight="true" style="position: absolute; left: 49px; top: 56px;"></sui-jqx-grid>
    <sui-jqx-grid :dataSource="defaultGridData.dataSource" :columns="defaultGridData.columns" :columnsautoresize="true" :autoheight="true" style="position: absolute; left: 48px; top: 318px;"></sui-jqx-grid>
  </div>
</template>
<script>
  export default {
    name: 'CompDatasetGrid',
    data() {
      return {
        defaultGridData: {
          dataSource: {
            localdata: [
              ['Alfreds Futterkiste', 'Berlin', 'Germany'],
              ['Ana Trujillo Emparedados y helados', 'Mxico D.F.', 'Mexico'],
              ['Antonio Moreno Taquera', 'Mxico D.F.', 'Mexico'],
              ['Around the Horn', 'London', 'UK'],
              ['Berglunds snabbkp', 'Lule', 'Sweden'],
              ['Blauer See Delikatessen', 'Mannheim', 'Germany'],
            ],
            datafields: [{
                name: 'CompanyName',
                type: 'string',
                map: '0',
              },
              {
                name: 'City',
                type: 'string',
                map: '1',
              },
              {
                name: 'Country',
                type: 'string',
                map: '2',
              },
            ],
            datatype: 'array',
          },
          columns: [{
              text: 'Company Name',
              datafield: 'CompanyName',
            },
            {
              text: 'City',
              datafield: 'City',
            },
            {
              text: 'Country',
              datafield: 'Country',
            },
          ],
        },
      };
    },
  };
</script>
<style scoped>
</style>
